import { Play, Pause } from 'lucide-react';
import { useState, useRef } from 'react';

export default function VideoPlayer({ 
  vimeoId, 
  vimeoHash,
  posterImage, 
  title = 'Video',
  className = '' 
}) {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const iframeRef = useRef(null);

  const handlePlay = () => {
    setIsPlaying(true);
    setIsLoaded(true);
  };

  // If no vimeoId, show placeholder
  if (!vimeoId) {
    return (
      <div className={`relative aspect-video bg-[#121212] ${className}`}>
        <img
          src={posterImage || 'https://images.pexels.com/photos/3379937/pexels-photo-3379937.jpeg'}
          alt={title}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
          <div className="text-center">
            <div className="w-20 h-20 rounded-full border-2 border-white/30 flex items-center justify-center mb-4 mx-auto">
              <Play size={32} className="text-white/50 ml-1" />
            </div>
            <p className="text-[#A1A1AA] text-sm">Video coming soon</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`relative aspect-video bg-[#121212] overflow-hidden ${className}`}>
      {!isPlaying && (
        <>
          <img
            src={posterImage || 'https://images.pexels.com/photos/3379937/pexels-photo-3379937.jpeg'}
            alt={title}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/40" />
          <button
            onClick={handlePlay}
            className="absolute inset-0 flex items-center justify-center group"
            data-testid={`play-video-${title.toLowerCase().replace(/\s+/g, '-')}`}
            aria-label={`Play ${title}`}
          >
            <div className="w-20 h-20 rounded-full bg-[#007AFF] flex items-center justify-center transition-transform group-hover:scale-110">
              <Play size={32} className="text-white ml-1" />
            </div>
          </button>
        </>
      )}
      
      {isLoaded && (
        <iframe
          ref={iframeRef}
          src={`https://player.vimeo.com/video/${vimeoId}?${vimeoHash ? `h=${vimeoHash}&` : ''}autoplay=1&title=0&byline=0&portrait=0`}
          className="absolute inset-0 w-full h-full"
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          title={title}
        />
      )}
    </div>
  );
}

export function VideoBackground({ vimeoId, posterImage, children, className = '' }) {
  // For background videos, we use a different approach
  return (
    <div className={`relative ${className}`}>
      {vimeoId ? (
        <div className="absolute inset-0 overflow-hidden">
          <iframe
            src={`https://player.vimeo.com/video/${vimeoId}?background=1&autoplay=1&loop=1&muted=1`}
            className="absolute w-[177.78vh] min-w-full min-h-full top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
            frameBorder="0"
            allow="autoplay; fullscreen"
            title="Background video"
          />
        </div>
      ) : (
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${posterImage})` }}
        />
      )}
      {children}
    </div>
  );
}
